if (!customElements.get('sw-homepage-hero')) {
  customElements.define('sw-homepage-hero', class extends HTMLElement {
    connectedCallback() {
      this.onReviewClick = (event) => {
        const link = event.target.closest('[data-reviews-target]');
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const id = link.dataset.reviewsTarget;
        const target = document.getElementById(id) || Array.from(document.querySelectorAll('[id^="shopify-section-"]')).find(section => section.id.endsWith('__' + id));
        if (!target) return;
        event.preventDefault();
        const header = document.querySelector('#shopify-section-header, .shopify-section--header');
        const offset = header ? header.getBoundingClientRect().height : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
        window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        // The resolved hash remains usable on reload; preserve the preview URL query.
        history.replaceState(history.state, '', '#' + target.id);
        const focusTarget = target.querySelector('h1, h2, h3, [role="heading"]') || target;
        if (!focusTarget.hasAttribute('tabindex')) {
          focusTarget.setAttribute('tabindex', '-1');
          focusTarget.addEventListener('blur', () => focusTarget.removeAttribute('tabindex'), { once: true });
        }
        focusTarget.focus({ preventScroll: true });
      };
      this.addEventListener('click', this.onReviewClick);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onReviewClick);
    }
  });
}
